export const ICON_NAMES = [
  'medical-kit',
  'briefcase-medical',
  'alert-triangle',
  'circle-alert',
  'circle-check',
  'circle-x',
  'info',
  'eye-off',
  'circle-question',
  'shield-check',
  'bolt',
  'clock',
  'download',
  'external-link',
  'arrow-right',
  'arrow-up-long',
  'arrow-down-long',
  'arrow-up-right',
  'arrow-down-right',
  'rotate-left',
  'check',
  'chevron-up',
  'chevron-down',
  'chevron-right',
  'chevron-left',
  'ellipsis',
  // Exact v3 report-toolbar concepts. The registry owns the Font Awesome mapping; product
  // callers own semantic placement through the reports feature mapping.
  'diagram-project',
  'objects-align-right',
  'sliders',
  'bookmark',
  'expand',
  'compress',
  'ellipsis-vertical',
  'gear',
  'plus',
  'filter',
  'search',
  'square-pen',
  'square-check',
  'pencil',
  'pen-to-square',
  'pen',
  'gem',
  'alert-sensor',
  'sparkle',
  'panel-left',
  'sidebar-right',
  'messages',
  'menu',
  'megaphone',
  'message-dot',
  'thumbs-up',
  'paper-airplane',
  'sparkles',
  'x',
  // Shell-only legacy equivalents. These names preserve the v3 navigation meaning without
  // exposing Font Awesome classes to product callers.
  'magnifying-glass-chart',
  'circle-nodes',
  'folder-image',
  'chart-line-up',
  'rocket-launch',
  'user',
  'globe',
  'clipboard-list',
  'clipboard-check',
  'block-quote',
  'chart-user',
  'folder',
  'cart-shopping',
  'plane-departure',
  'mobile-screen-button',
  'orpheus',
  // Module 12's seven connector categories (`INTEGRATIONS_TYPES`).
  'layer-group',
  // Commerce report tabs retain typed semantic names while the registry resolves FA glyphs.
  'box',
  'boxes-stacked',
  'cart-flatbed-boxes',
  'chart',
  'database',
  'ad',
  'cart',
  'users',
  'mobile',
  'code',
  // The two sidebar report groups (Creative Performance, Travel) whose v3 glyphs had no token
  // here, so both fell back to `circle-question` in the nav rail.
  'image',
  'video',
  'type',
  'plane',
  'trash',
  'arrow-left',
  'lock',
  'lock-open',
  'coins',
  'play',
  'calendar-check',
  'calendar-days',
  'caret-down',
  'sun',
  'moon',
  'repeat',
  'sack-dollar',
  'traffic-cone',
  'browser',
  'eye',
  'heart',
  'door-open',
  'right-to-bracket',
  'link-slash',
  'arrow-pointer',
  'hand',
  'chart-mixed',
  'money-bill',
  // Report-tab concepts carried over from the v3 Font Awesome catalog.
  'images',
  'video-monitor',
  'text',
  'boxes-packing',
  'folder-arrow-up',
  'folder-tree',
  'list-tree',
  'hexagon-nodes',
  'gallery-thumbnails',
  'arrow-trend-up',
  'arrow-up-wide-short',
  'arrow-trend-down',
  'image-stack',
  'photo-film',
  'list-dropdown',
  'object-group',
  'list-magnifying-glass',
  'users-viewfinder',
  'line-columns',
  'hand-holding-dollar',
  'person-half-dress',
  'location-dot',
  'chart-line',
  'chart-area',
  'window-restore',
  'comment-plus',
  'bug',
  'display',
  'id-badge',
  'network-wired',
  'bell',
  'address-book',
  'file-invoice',
  'file-pdf',
  'copy',
  // Report chart-type picker glyphs, mirrored from new-front's CHART_ICONS catalog (same
  // Font Awesome Pro kit).
  'chart-bar',
  'chart-pie',
  'chart-donut',
  'chart-scatter',
  'chart-scatter-bubble',
  'table-cells-large',
  'grid-2',
  'grip-vertical',
  'filter-circle-dollar',
  'chart-waterfall',
  'radar',
  'gauge-high',
  'diagram-predecessor',
  'lollipop',
  // Former inline-SVG glyphs (auth fields, media viewer, form controls) moved onto the kit.
  'building',
  'envelope',
  'arrow-up',
  'arrow-down',
  'arrow-rotate-right',
  'magnifying-glass-plus',
  'magnifying-glass-minus',
  'image-slash',
  'minus',
  // Orpheus: the provider-key rows and the KPI target-file attachment (ORP-25170, ORP-26203).
  'key',
  'paperclip',
  'file-csv',
  'file-excel',
  // AI credits panel feature glyphs, mirrored from new-front's `creditPresentation.ts` (ORP-18685).
  'wave-square',
  'pen-swirl',
  // Connections' "Finish setup" affordance (v3 `AuthenticateCard.vue`).
  'circle-plus',
  // The Orphex MCP sidebar leaf (ORP-27467), v3's plug glyph.
  'plug',
] as const

export type IconName = (typeof ICON_NAMES)[number]
export type FontAwesomeWeight =
  'solid' | 'regular' | 'light' | 'thin' | 'duotone' | 'brands' | 'kit'

export interface IconProps {
  name: IconName
  size?: number
  /** Font Awesome family; legacy rail defaults to light and other contexts default to solid. */
  weight?: FontAwesomeWeight
  /** Optional shared optical recipe for contexts whose glyph bounds are part of parity. */
  presentation?: 'default' | 'legacy-rail'
  /** Localized accessible name. Omit for a decorative icon. */
  label?: string
}
